module.exports = __webpack_public_path__ + "images/FUSA_icons/011-online-shop-10.c360528d1086b602dfb59ed24bc88263.svg";